import {
  getEndDateBasedStartAndQty,
  getOverallEndDate,
  getOverallQty,
  getQtyBasedEndStartDate,
  setUnits
} from './authUtils';

export const _setModality = (state, action) => {
  //console.log('### SET MODALITY STATE')
  //console.log(action.payload)
  state.modality = action.payload;
  setUnits(state);
};
export const _setCommunityBasedProvider = (state, action) => {
  state.communityBasedProvider = action.payload;
};
export const _setBudgetType = (state, action) => {
  state.budgetType = action.payload;
};
export const _setAuthType = (state, action) => {
  state.authType = action.payload;
};
export const _setFundingOrg = (state, action) => {
  state.fundingOrg = action.payload;
};
export const _setTransferForm = (state, action) => {
  state.transferForm = action.payload;
};
export const _setInitialReferral = (state, action) => {
  state.initialReferral = action.payload;
};
export const _setAthIssueDate = (state, action) => {
  state.athIssueDate = action.payload;
};
export const _setExt1IssueDate = (state, action) => {
  state.ext1IssueDate = action.payload;
};
export const _setExt2IssueDate = (state, action) => {
  state.ext2IssueDate = action.payload;
};
export const _setAuthorizedByOriginal = (state, action) => {
  state.authorizedByOriginal = action.payload;
};
export const _setAuthorizedByExtension1 = (state, action) => {
  state.authorizedByExtension1 = action.payload;
};
export const _setAuthorizedByExtension2 = (state, action) => {
  state.authorizedByExtension2 = action.payload;
};

export const _setExt1StartDate = (state, action) => {
  state.ext1StartDate = action.payload;
  state.ext1EndDate = getEndDateBasedStartAndQty(
    state.ext1StartDate,
    state.ext1DayQty,
    state.daysAuthorisedDayDelay
  );
};
export const _setExt2StartDate = (state, action) => {
  state.ext2StartDate = action.payload;
  state.ext2EndDate = getEndDateBasedStartAndQty(
    state.ext2StartDate,
    state.ext2DayQty,
    state.daysAuthorisedDayDelay
  );
};
export const _setDaysAuthorisedQty = (state, action) => {
  //console.log('### MODALITY FROM SET AUTH DAYS');
  //console.log(state.modality.isResidential);

  state.daysAuthorisedQty = action.payload;
  state.authEndDate = getEndDateBasedStartAndQty(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.daysAuthorisedDayDelay
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality.isResidential,
    state.daysAuthorisedDayDelay
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality.isResidential,
    state.daysAuthorisedDayDelay
    //state.ext1DayQty,
    //state.ext2DayQty
  );
  setUnits(state);
};
export const _setExt1DayQty = (state, action) => {
  state.ext1DayQty = action.payload;
  state.ext1EndDate = getEndDateBasedStartAndQty(
    state.ext1StartDate,
    state.ext1DayQty
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality.isResidential
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality.isResidential
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};
export const _setExt2DayQty = (state, action) => {
  state.ext2DayQty = action.payload;
  state.ext2EndDate = getEndDateBasedStartAndQty(
    state.ext2StartDate,
    state.ext2DayQty
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality.isResidential
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality.isResidential
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};
export const _setDaysAuthorisedDayDelay = (state, action) => {
  state.daysAuthorisedDayDelay = action.payload;
  state.authEndDate = getEndDateBasedStartAndQty(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.daysAuthorisedDayDelay
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality?.isResidential,
    state.daysAuthorisedDayDelay
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality?.isResidential,
    state.daysAuthorisedDayDelay
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};

export const _setExt1EndDate = (state, action) => {
  state.ext1EndDate = action.payload;
  state.ext1DayQty = getQtyBasedEndStartDate(
    state.ext1StartDate,
    state.ext1EndDate
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality.isResidential
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality.isResidential
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};
export const _setExt2EndDate = (state, action) => {
  state.ext2EndDate = action.payload;
  state.ext2DayQty = getQtyBasedEndStartDate(
    state.ext2StartDate,
    state.ext2EndDate
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality.isResidential
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality.isResidential
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};
export const _setOverAllStartDate = (state, action) => {
  state.overAllStartDate = action.payload;
};
export const _setOverallQty = (state, action) => {
  state.overallQty = action.payload;
};
export const _setOverAllEndDate = (state, action) => {
  state.overAllEndDate = action.payload;
};
export const _setUnitsTotal = (state, action) => {
  state.unitsTotal = action.payload;
};
export const _setMaxUnitsPerWeek = (state, action) => {
  state.maxUnitsPerWeek = action.payload;
};
export const _setMaxIndsPerWeek = (state, action) => {
  state.maxIndsPerWeek = action.payload;
};
export const _setMaxGrpsPerWeek = (state, action) => {
  state.maxGrpsPerWeek = action.payload;
};
export const _setCbpAdmitDate = (state, action) => {
  state.cbpAdmitDate = action.payload;
};
export const _setCbpDischargeDate = (state, action) => {
  state.cbpDischargeDate = action.payload;
};
export const _setAuthStartDate = (state, action) => {
  state.authStartDate = action.payload;
  state.overAllStartDate = action.payload;
  state.authEndDate = getEndDateBasedStartAndQty(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.daysAuthorisedDayDelay
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality?.isResidential
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};
export const _setAuthEndDate = (state, action) => {
  state.authEndDate = action.payload;
  state.daysAuthorisedQty = getQtyBasedEndStartDate(
    state.authStartDate,
    state.authEndDate
  );
  state.overallQty = getOverallQty(
    state.daysAuthorisedQty,
    state.ext1DayQty,
    state.ext2DayQty,
    state.modality?.isResidential,
    state.daysAuthorisedDayDelay
  );
  state.overAllEndDate = getOverallEndDate(
    state.authStartDate,
    state.daysAuthorisedQty,
    state.modality?.isResidential,
    state.daysAuthorisedDayDelay
    //state.ext1DayQty,
    //state.ext2DayQty
  );
};
export const _setPlacementType = (state, action) => {
  state.placementType = action.payload;
};
export const _setRelapse = (state, action) => {
  state.relapse = action.payload;
};
export const _setAuthComment = (state, action) => {
  state.authComment = action.payload;
};
export const _setCompletionSurveyAdministered = (state, action) => {
  state.completionSurveyAdministered = action.payload;
};
export const _setAuthIsLocked = (state, action) => {
  //console.log('### IS LOCKED PAYLOAD')
  //console.log(action)
  state.authIsLocked = action.payload.value;
  //state.authorizationReviewedBy = action.payload.user;
  //state.reviewDate = new Date();
};
export const _setAdministrativeTransferAdmit = (state, action) => {
  state.administrativeTransferAdmit = action.payload;
};
export const _setAuthorizationReviewedBy = (state, action) => {
  //console.log('### REVIEWED BY PAYLOAD')
  //console.log(action)

  state.authorizationReviewedBy = action.payload;
};
export const _setReviewDate = (state, action) => {
  state.reviewDate = action.payload;
};
export const _setAthTPRcd = (state, action) => {
  //console.log('_setAthTPRcd with')
  //console.log(action)
  state.athTPRcd = action.payload;
};
export const _setAth1502Rcd = (state, action) => {
  //console.log('_setAth1502Rcd with')
  //console.log(action)
  state.ath1502Rcd = action.payload;
};
